import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import PreviousOpensComponent from './js/previous-opens.component';

ComponentsFactory.getInstance().define('previous-opens', PreviousOpensComponent);
